export const GET_CUSTOM_FORMS = 'GET_CUSTOM_FORMS';
export const GET_CUSTOM_FORMS_SUCCESS = 'GET_CUSTOM_FORMS_SUCCESS';
export const GET_CUSTOM_FORMS_FAILED = 'GET_CUSTOM_FORMS_FAILED';

export const ADD_CUSTOM_FORMS = 'ADD_CUSTOM_FORMS';
export const ADD_CUSTOM_FORMS_SUCCESS = 'ADD_CUSTOM_FORMS_SUCCESS';
export const ADD_CUSTOM_FORMS_FAILED = 'ADD_CUSTOM_FORMS_FAILED';

export const EDIT_CUSTOM_FORMS = 'EDIT_CUSTOM_FORMS';
export const EDIT_CUSTOM_FORMS_SUCCESS = 'EDIT_CUSTOM_FORMS_SUCCESS';
export const EDIT_CUSTOM_FORMS_FAILED = 'EDIT_CUSTOM_FORMS_FAILED';

export const DELETE_CUSTOM_FORMS = 'DELETE_CUSTOM_FORMS';
export const DELETE_CUSTOM_FORMS_SUCCESS = 'DELETE_CUSTOM_FORMS_SUCCESS';
export const DELETE_CUSTOM_FORMS_FAILED = 'DELETE_CUSTOM_FORMS_FAILED';
